var module = angular.module('octopusApp.projects');

module.directive('projectLogo', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            project: '=',
            maxSize: "@"
        },
        template: '<img class="project-logo" ng-src="{{ project.Links.Logo | resolveLink }}?cb={{random}}" style="max-width: {{maxSize}}; max-height: {{maxSize}}" ng-show="project.Links.Logo"/>',
        link: function ($scope, element, attr) {
            $scope.random = Math.round(new Date().getTime() / 1000);
        }
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/project_logo.js
// module id = 550
// module chunks = 1